<template>
  <!-- 联合利华竞赛 -->
  <div class="wrap">
    <Spin fix class="ivu-spin-fullscreen" :class="{'dt-none': isLoading === false }">
      <Icon type="load-c" size="18" class="demo-spin-icon-load"></Icon>
      <div>{{loadingText}}</div>
    </Spin>
    <div class="map-layout">
      <header class="head-style">
        <span class="title-cont title-style bold">日期</span>
        <span class="title-cont title-style">{{today}}</span>
        <span class="title-cont title-style bold">拜访客户数</span>
        <span class="title-cont title-style">{{orderCust}}个</span>
        <span class="title-cont title-style bold">预计行程</span>
        <span class="title-cont title-style">{{totalKm}}km</span>

        <span class="title-cont title-style bold" style="clear: left">预计时长</span>
        <span class="title-cont title-style">{{totalTime}}min</span>
        <span class="title-cont title-style bold">预计花费</span>
        <span class="title-cont title-style">{{totalCost}}元</span>
        <!-- <span class="title-cont title-style bold">预计开始时间</span>
        <span class="title-cont title-style">{{startTime}}</span>
        <span class="title-cont title-style bold">预计结束时间</span>
        <span class="title-cont title-style">{{endTime}}</span>-->
        <Button
          type="primary"
          class="btn-table"
          @click="clickShowCalendar"
          v-if="false"
        >{{showCalendarName}}</Button>
        <Button
          type="primary"
          class="btn-table margin-right-10"
          @click="clickShowTab"
        >{{shoTabName}}</Button>
      </header>
      <div class="right">
        <div class="visit-panel">
          <div class="select-user-panel select-condition">
            <div class="select-user-block">
              <span class="select-user-title">城市</span>
              <Select
                v-model="citySlect"
                class="select-user text-center margin-top-10"
                @on-change="changeCity(citySlect)"
              >
                <Option
                  v-for="city in cities"
                  :key="city.value"
                  :value="city.value"
                >{{ city.label }}</Option>
              </Select>
            </div>
            <div class="select-user-block">
              <span class="select-user-title">人员</span>
              <Select
                v-model="userSelect"
                class="select-user text-center margin-top-10"
                :label-in-value="true"
                @on-change="changCar"
              >
                <Option
                  v-for="user in userAlls"
                  :key="user.label"
                  :value="user.value"
                >{{ user.label }}</Option>
              </Select>
            </div>
          </div>
          <div id="calendar" class="margin-top-8"></div>
          <div class="current-month-num current-month-heitht">
            <p class="title">统计详情</p>
            <div class="current-month-num-body">
              <div class="all-line-info font-bold">
                <span class="with-50">本月拜访用户数</span>
                <span>{{monthCount}}</span>个
              </div>
              <Col class="all-line-info font-bold">
                <span class="with-50">本月预计总行程</span>
                <span>{{monthDistance/1000}}km</span>
              </Col>
              <Col class="all-line-info font-bold">
                <span class="with-50">本月预计总时长</span>
                <span>{{monthDurction.toFixed(2)}}min</span>
              </Col>
              <Col class="all-line-info font-bold">
                <span class="with-50">本月预计总花费</span>
                <span>{{monthCost}}元</span>
              </Col>
            </div>
          </div>
          <div v-show="false" class="future-visit-panel height-295">
            <p class="title">未排入本月PJP的客户（{{futureVisit.length}}）</p>
            <div class="future-visit-panel-body">
              <div class="visit-item" v-for="visit in futureVisit">
                <Col span="12" class="visit-custorm">{{visit.attrs.CustomerName}}</Col>
                <Col span="12" class="add-daily" style="text-align:right;">
                  <span>+</span>
                  加入日程
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="left" ref="mapPanel">
        <Table v-show="showTable" :columns="tableTitle" :data="tableItems" class="table-styles"></Table>
        <div id="mapContainer" class="map-style"></div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import CreateDate from "./CreateDate.vue";
import "../assets/stylesheets/map_competion.scss";
import "../assets/stylesheets/calendar.css";
import "../assets/javascript/jquery.min.js";
import api from "../service/api";
import getData from "../service/getData";
import getColor from "../service/randomColor.js";
import { setTimeout } from "timers";
import io from "socket.io-client";
import config from "../../config/config.js";
import moment from "moment";
import demoUser from "../data/demoUser.js";
import "../assets/javascript/calendal.js";
import {
  initMap,
  openMarWindow,
  openLineWindow
} from "../assets/javascript/map.js";
import { throws } from "assert";
const labelNames = {
  city: "城市",
  name: "门店名称",
  address: "门店地址",
  district: "县级市名称",
  storeType: "门店类型",
  salesChannel: "销售渠道",
  vistUser: "拜访人员",
  interval: "间隔",
  days: "拜访日期",
  frequence: "月拜访频率",
  durction: "停留时间"
};

export default {
  data() {
    return {
      isLoading: false,
      loadingText: "加载中...",
      today: "",
      orderCust: 0,
      totalKm: "0",
      totalCost: 0,
      totalWeitht: "0",
      totalTime: 0,
      startTime: "00:00",
      endTime: "00:00",
      citySlect: "太原",
      cities: [
        {
          value: "太原",
          label: "太原"
        }
      ],
      tableTitle: [
        {
          title: "拜访顺序",
          key: "order",
          width: 90
        },
        {
          title: "门店编号",
          key: "id",
          width: 90
        },
        {
          title: "门店名称",
          key: "name",
          minWidth: 120
        },
        {
          title: "预计到达时间",
          key: "time",
          minWidth: 120
        },
        {
          title: "离开时间",
          key: "leaveTime",
          minWidth: 100
        }
      ],
      tableItems: [],
      userSelect: 0,
      userAlls: [
        {
          value: 0,
          label: "全部"
        }
      ],
      users: [],
      custCount: 0, //全部的客户数
      visitDistance: 0,
      visitDurction: 0,
      visitDays: 0,
      restDays: 0,
      futureVisit: [],
      layerGroup: new L.layerGroup(),
      layerMap: new Map(), //用来存储现在显示的
      showTable: false,
      shoTabName: "展示列表",
      pointsMap: new Map(), //保存全部的客户
      carInfoMap: new Map(), //每辆车的统计详情
      dayGroupMap: new Map(), //根据日期保存全部的线路,点要素
      userGroupMap: new Map(), //根据人保存全部的线路,点要素
      showLayerGroup: [], //用来展示去除展示的图层
      focusLayers: [], // 焦点图层
      focusLineLayer: null,
      focusMarker: null, // 焦点点位
      indexToDayMap: new Map(), //将天数和日期相对应
      monthCount: 0,
      monthDistance: 0,
      monthDurction: 0,
      monthCost: 0
    };
  },
  computed: {},
  mounted() {
    this.map = initMap(); //初始化地图
    this.map.on("popupclose", this.clearFocus);
    this.layerGroup.addTo(this.map);
    this.getFileData();
  },
  methods: {
    async getFileData() {
      let startDay = moment("2019-10-01", "YYYY-MM-DD");
      for (let i = 0; i < 22; i++) {
        while (startDay.day() === 0 || startDay.day() === 6) {
          //说明是周六日需要休息
          startDay = startDay.add(1, "d");
        }
        this.indexToDayMap.set(i, startDay.format("YYYY-MM-DD"));
        startDay = startDay.add(1, "d");
      }

      const res = await getData.get(api.getFileData, {
        // fileName: "联合利华竞赛结果整理多种交通方式"
        // fileName: "联合利华竞赛结果整理多种交通方式去除最后一个人"
        fileName: "联合利华竞赛结果整理多种交通方式优化时间最终"

        // fileName: "联合利华竞赛最终结果"
        // fileName: "联合利华竞赛-最终结果"
      });

      if (res.data && res.data.status) {
        for (const point of res.data.info.points_all) {
          this.pointsMap.set(point.id, point);
        }
        this.drawPoints([...this.pointsMap.values()]);
        this.drawLines(res.data.info.line_info);
      }

      for (let userId of [...this.userGroupMap.keys()]) {
        this.userAlls.push({
          value: userId,
          label: `人员${userId}`
        });
      }
      this.setCalendarData([...this.dayGroupMap.values()]);
    },
    drawPoints(usePoints) {
      const allMarkerLayers = []; //只有展示全部的时候才显示
      let color = getColor.getColor(); //每辆车一个颜色
      color = "red";
      for (let point of usePoints) {
        const marPups = [];
        for (let objKey in point) {
          //循环遍历key
          if (
            ["type", "visits", "days", "interval", "vistUser"].indexOf(objKey) >
            -1
          ) {
            continue;
          }
          let value = point[objKey];
          if (objKey === "vistUser") {
            value = this.getVisitors(value);
          }
          if (objKey === "days") {
            value = this.formatDays(value);
          }
          marPups.push({
            name: labelNames[objKey] || objKey,
            cont: value
          });
        }
        allMarkerLayers.push(
          L.circleMarker([point.lat, point.lng], {
            radius: 3,
            color: color
          }).on("click", e => {
            // if (marPups[0].cont === "startPoint") {
            //   alert("为起点");
            // } else {
            openMarWindow(e, marPups);
            // }
          })
        );
      }
      const allCircGroup = L.featureGroup(allMarkerLayers);
      this.map.fitBounds(allCircGroup.getBounds());
      allCircGroup.addTo(this.map);
      this.showLayerGroup.push(allCircGroup);
    },
    drawLines(useLines) {
      for (let linfo of useLines) {
        const layers = []; //同一条线上的点和线
        const color = getColor.getColor(); //每辆车一个颜色
        for (let index = 0, n = linfo.route_info.length; index < n; index++) {
          const pointId = linfo.point_ids[index];
          const point = this.pointsMap.get(pointId);
          const route = linfo.route_info[index];

          // 画点
          let label = index + 1;
          if (index === 0) {
            label = "起";
          } else if (index === n - 1) {
            label = "终";
          }
          const divHtml = `<div class='way-points' style='background-color:${color}'>${label}</div>`;
          const wayDivIcon = new L.divIcon({
            html: divHtml,
            className: "leaflet-direction-icon"
          });
          const marPups = [];
          for (let objKey in point) {
            //循环遍历key
            if (
              ["type", "visits", "days", "interval", "vistUser"].indexOf(
                objKey
              ) > -1
            ) {
              continue;
            }
            let value = point[objKey];
            if (objKey === "vistUser") {
              value = this.getVisitors(value);
            }
            if (objKey === "days") {
              value = this.formatDays(value);
            }
            marPups.push({
              name: labelNames[objKey] || objKey,
              cont: value
            });
          }
          marPups.push(
            { name: "预计到达时间", cont: route.time },
            { name: "离开时间", cont: route.leaveTime }
          );
          layers.push(
            L.marker([point.lat, point.lng], {
              icon: wayDivIcon
            }).on("click", e => {
              // if (marPups[0].cont === "startPoint") {
              //   alert("为起点");
              // } else {
              openMarWindow(e, marPups);
              this.setFocusMarker(e);
              // }
            })
          );
          // 划线
          if (route.path === "") continue;
          let vehicles = [];
          for (let vehstr of route.vehicle_types) {
            if (vehstr.type === 1) {
              vehicles.push({
                name: "步行",
                cont: `${vehstr.distance}米`
              });
            } else if (vehstr.type === 2) {
              vehicles.push({
                name: "公交",
                cont: vehstr.busName
              });
            } else if (vehstr.type === 3) {
              vehicles.push({
                name: "驾车",
                cont: `${(vehstr.distance / 1000).toFixed(2)}公里`
              });
            }
          }
          const attrRoutes = [
            {
              name: "拜访人员",
              cont: `人员${linfo.userId}`
            },
            {
              name: "拜访日期",
              cont: this.indexToDayMap.get(linfo.day)
            },
            {
              name: "总共里程",
              cont: `${(linfo.distance / 1000).toFixed(2)} 公里`
            },
            {
              name: "分段里程",
              cont: `${(route.distance / 1000).toFixed(2)} 公里`
            },
            {
              name: "总共时长",
              cont: `${linfo.durction.toFixed(2)} 分钟`
            },
            {
              name: "分段时长",
              cont: `${route.durction.toFixed(2)}分钟`
            },
            {
              name: "总共费用",
              cont: `${linfo.cost.toFixed(2)}元`
            },
            {
              name: "分段费用",
              cont: `${route.cost.toFixed(2)}元`
            },
            {
              name: "通勤方式",
              vehicles
            }
          ];

          const latLngs = [];
          const routes = route.path.split(";");
          for (let route of routes) {
            latLngs.push(route.split(",").reverse());
          }
          layers.push(
            L.polyline(latLngs, {
              color: color
            }).on("click", e => {
              openLineWindow(e, attrRoutes);
              this.setFocusLineLayer(layers, latLngs);
            })
          );
        }
        const featureGroup = L.featureGroup(layers);
        featureGroup.lineInfo = linfo;

        //根据人员和日期两个维度保存数据
        if (this.dayGroupMap.has(linfo.day)) {
          this.dayGroupMap.get(linfo.day).push(featureGroup);
          this.dayGroupMap.set(linfo.day, this.dayGroupMap.get(linfo.day));
        } else {
          this.dayGroupMap.set(linfo.day, [featureGroup]);
        }
        if (this.userGroupMap.has(linfo.userId)) {
          //根据人员保存
          const userLayerMap = this.userGroupMap.get(linfo.userId);
          userLayerMap.set(linfo.day, [featureGroup]);
          this.userGroupMap.set(linfo.userId, userLayerMap);
        } else {
          const userLayerMap = new Map();
          userLayerMap.set(linfo.day, [featureGroup]);
          this.userGroupMap.set(linfo.userId, userLayerMap);
        }
      }
    },
    setCalendarData(useDatas) {
      this.monthCount = 0;
      this.monthDistance = 0;
      this.monthDurction = 0;
      this.monthCost = 0;
      for (let dayInfo of useDatas) {
        for (let dayLine of dayInfo) {
          this.monthCount += dayLine.lineInfo.point_ids.length - 1;
          this.monthCost += dayLine.lineInfo.cost;
          this.monthDistance += dayLine.lineInfo.distance;
          this.monthDurction += dayLine.lineInfo.durction;
        }
      }

      const dates = {};
      let startDay = moment("2019-10-01", "YYYY-MM-DD");
      for (let i = 0; i < useDatas.length; i++) {
        while (startDay.day() === 0 || startDay.day() === 6) {
          //说明是周六日需要休息
          dates[startDay.format("YYYYMMDD")] = "h";
          startDay = startDay.add(1, "d");
        }
        const userDataInfos = useDatas[i];
        let orderNum = 0;
        for (const userDataInfo of userDataInfos) {
          orderNum += userDataInfo.lineInfo.point_ids.length - 1;
        }
        dates[startDay.format("YYYYMMDD")] = {
          orderCounts: orderNum,
          layerGroups: useDatas[i]
        };
        startDay = startDay.add(1, "d");
      }
      //设置对应的日历数据
      const self = this;
      $("#calendar").empty();
      $("#calendar").calendar({
        ifSwitch: true, // 是否切换月份
        hoverDate: false, // hover是否显示当天信息
        backToday: false, // 是否返回当天
        selected_data: self.today.replace(/-/g, ""),
        dates,
        afterInit(today) {
          if (today) {
            self.today = today.replace(/-/g, "");
          }
        },
        onMonthChange(date) {},
        onClick(today, selectDay) {
          self.today = selectDay;
          self.clearLayer();
          self.totalTime = 0;
          self.totalKm = 0;
          self.orderCust = 0;
          self.totalCost = 0;

          self.tableItems = [];

          selectDay = selectDay.replace(/-/g, "");
          if (!dates[selectDay] || !dates[selectDay].layerGroups) {
            return;
          }
          for (let featureGroup of dates[selectDay].layerGroups) {
            featureGroup.addTo(self.map);
            self.showLayerGroup.push(featureGroup);
            self.orderCust += featureGroup.lineInfo.point_ids.length - 1;
            self.totalTime += featureGroup.lineInfo.durction;
            self.totalKm += featureGroup.lineInfo.distance;
            self.totalCost += featureGroup.lineInfo.cost;

            // for (let pointId of featureGroup.lineInfo.point_ids) {
            for (
              let index = 0;
              index < featureGroup.lineInfo.point_ids.length;
              index++
            ) {
              let pointId = featureGroup.lineInfo.point_ids[index];
              let routeInfo = featureGroup.lineInfo.route_info[index];
              const getPoint = self.pointsMap.get(pointId);
              self.tableItems.push({
                order: index + 1,
                id: getPoint.id === "startPoint" ? getPoint.id : getPoint.orId,
                name: getPoint.id === "startPoint" ? "起点" : getPoint.name,
                menType: getPoint.id === "startPoint" ? "" : getPoint.storeType,
                saleChinal:
                  getPoint.id === "startPoint" ? "" : getPoint.salesChannel,
                frequence:
                  getPoint.id === "startPoint" ? "" : getPoint.frequence,
                time: routeInfo.time,
                leaveTime: routeInfo.leaveTime
              });
            }
          }
          self.totalTime = self.totalTime.toFixed(2);
          self.totalKm = (self.totalKm / 1000).toFixed(2);
        }
      });
    },
    changCar(indexCar) {
      this.clearLayer();
      if (indexCar.value === 0) {
        //加载全部的
        this.setCalendarData([...this.dayGroupMap.values()]);
      } else {
        //只加载对应的客户的
        this.setCalendarData([
          ...this.userGroupMap.get(indexCar.value).values()
        ]);
      }
    },
    clearLayer() {
      for (let layersGroup of this.showLayerGroup) {
        layersGroup.remove();
      }
    },
    clearFocus() {
      this.clearFocusLineLayer();
      this.clearFocusMarker();
    },
    /**
     * 焦点路线
     */
    setFocusLineLayer(layers, latLngs) {
      this.clearFocusLineLayer();
      for (let layer of layers) {
        if (layer.setZIndexOffset) {
          layer.setZIndexOffset(999);
        }
      }
      if (!this.focusLineLayer) {
        this.focusLineLayer = L.polyline(latLngs, {
          color: "#ff0000",
          weight: 5
        });
      } else {
        this.focusLineLayer.setLatLngs(latLngs);
      }
      this.focusLineLayer.addTo(this.map).bringToFront();
      this.focusLayers = layers;
    },
    clearFocusLineLayer() {
      for (let layer of this.focusLayers) {
        if (layer.setZIndexOffset) {
          layer.setZIndexOffset(0);
        }
      }
      this.focusLayers = [];
      if (this.focusLineLayer) {
        this.focusLineLayer.remove();
      }
    },
    /**
     * 点位焦点
     */
    setFocusMarker(e) {
      this.focusMarker = e.target;
      let dom = this.focusMarker.getElement();
      let className = dom.className;
      if (className.indexOf("focus-marker-point") === -1) {
        className += " focus-marker-point";
      }
      dom.className = className;
    },
    clearFocusMarker() {
      if (this.focusMarker) {
        let dom = this.focusMarker.getElement();
        if (dom !== null) {
          let className = dom.className;
          if (className.indexOf("focus-marker-point") > -1) {
            className = className.replace(" focus-marker-point", "");
          }
          dom.className = className;
        }
      }
      this.focusMarker = null;
    },
    clickShowTab() {
      this.showTable = !this.showTable;
      this.shoTabName =
        this.shoTabName === "展示列表" ? "隐藏列表" : "展示列表";
    },
    /**
     * 过滤重复用户
     */
    getVisitors(cont) {
      let vistors = [];
      for (let i = 0, n = cont.length; i < n; i++) {
        if (vistors.indexOf(cont[i]) === -1) {
          vistors.push(cont[i]);
        }
      }
      return vistors.map(id => `人员${id}`);
    },
    formatDays(days) {
      let newDays = [];
      for (let key of days) {
        let value = this.indexToDayMap.get(key);
        if (value) {
          newDays.push(value);
        }
      }
      return newDays;
    }
  }
};
</script>
<style lang="less">
.map-layout .with-all-8 {
  width: calc(~"100% - 8px");
}
.wrap {
  height: 100%;
  position: relative;
}
.height-200 {
  height: 230px !important;
}
.all-line-info {
  text-align: left;
  font-size: 10px;
  margin: 4px;
}
.font-bold {
  font-weight: bold;
  font-size: 12px !important;
}
.bold {
  font-weight: bold;
}
.with-50 {
  display: inline-block;
  width: 90px;
}
.title-style {
  width: 90px;
  text-align: left;
}
.map-layout .left .ivu-table-wrapper.table-styles {
  width: 585px;
  z-index: 1001;
}
.table-styles {
  .ivu-table {
    .ivu-table-body {
      height: calc(100% - 8px);
      overflow-y: auto;
      width: calc(100% + 15px);
    }
    .ivu-table-overflowX {
      overflow-x: hidden;
      width: calc(100% + 15px);
    }
    overflow-x: hidden;
    // overflow-y: auto !important;
  }
}

.head-style {
  width: calc(~"100% - 436px");
  float: left;
  height: 60px;
  border-bottom: 1px solid #c9d3e0;
  padding-top: 8px;
  padding-left: 16px;
}
.select-condition {
  margin-top: 0 !important;
  height: 52px !important;
  line-height: 52px !important;
}
.margin-top-10 {
  margin-top: 10px !important;
}
.margin-top-8 {
  margin-top: 8px;
}
.float-left {
  float: left;
}
.btn-table {
  float: right;
  margin-top: -16px;
}
.title-cont {
  height: 22px;
  line-height: 22px;
  float: left;
  color: #576d8b;
  font-size: 14px;
}
.current-month-heitht {
  height: calc(~"100% - 55px") !important;
}
.height-295 {
  height: calc(~"100% - 295px") !important;
}

.way-points {
  width: 30px;
  height: 30px;
  line-height: 28px;
  margin-left: -10px;
  margin-top: -10px;
}
.focus-marker-point .way-points {
  background-color: #ff0000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Competiton.vue